import { Method } from '@/features/single-measurement/types';

import { YeastVolumeMatrix } from './calculation-helper';

export enum ActionKind {
  Reset = 'RESET',
  SetWort = 'SET_WORT',
  Calculate = 'CALCULATE',
  SetGravity = 'SET_GRAVITY',
  SetViability = 'SET_VIABILITY',
  SetPitchRate = 'SET_PITCH_RATE',
  SetConcentration = 'SET_CONCENTRATION',
  SetTargetConcentration = 'SET_TARGET_CONCENTRATION',
  ChangePlotGravity = 'CHANGE_PLOT_GRAVITY',
  ChangeWortVolumeUnit = 'CHANGE_WORT_VOLUME_UNIT',
  ChangeCalculationMethod = 'CHANGE_CALCULATION_METHOD',
}

export type Action =
  | { type: ActionKind.Reset }
  | { type: ActionKind.Calculate }
  | { type: ActionKind.SetWort; payload: number }
  | { type: ActionKind.SetGravity; payload: number }
  | { type: ActionKind.SetPitchRate; payload: number }
  | { type: ActionKind.SetViability; payload: number }
  | { type: ActionKind.SetConcentration; payload: number }
  | { type: ActionKind.SetTargetConcentration; payload: number }
  | { type: ActionKind.ChangeWortVolumeUnit; payload: WortUnits }
  | { type: ActionKind.ChangePlotGravity; payload: PlatoGravity }
  | { type: ActionKind.ChangeCalculationMethod; payload: CalculationMethod };

export enum WortUnits {
  Hectorliter = 'HECTORLITER',
  Liter = 'LITER',
  Mililiter = 'MILILITER',
  Gallon = 'GALLON',
  Barrels = 'BARRELS',
  Gram = 'GRAM',
  Kilogram = 'KILOGRAM',
  Pound = 'POUND',
  Ounce = 'OUNCE',
}

// in mobile app value correspond to CalculationMethod.WORT_FIXED_VOLUME & WORT_FINAL_VOLUME
export enum CalculationMethod {
  IncludingYeastVolume = 'INCLUDING_YEAST_VOLUME',
  ExcludingYeastVolume = 'EXCLUDING_YEAST_VOLUME',
}

export enum PlatoGravity {
  Plato = 'PLATO',
  Gravity = 'GRAVITY',
}

export interface IPitchState {
  wort?: number;
  gravity?: number;
  pitchRate?: number;
  targetConcentration?: number;
  concentration?: number;
  viability?: number;
  error: null | string;
  wortUnit: WortUnits;
  gravityType: PlatoGravity;
  calculationMethod: CalculationMethod;
  yeastVolume?: YeastVolumeMatrix;
  method?: Method;
}
